import { createAction } from 'redux-actions'

/** AUTH */
export const LOGIN = createAction('LOGIN')
export const LOGIN_START = createAction('LOGIN_START')
export const LOGIN_FINALLY = createAction('LOGIN_FINALLY')
export const LOGIN_ERROR = createAction('LOGIN_ERROR')

/** USER AUTH */
export const LOGIN_SET_AUTH = createAction('LOGIN_SET_AUTH')
export const LOGIN_SET_PROFILE = createAction('LOGIN_SET_PROFILE')